<div class="mfunsPlayer-resolution-mask">
  <div class="mfunsPlayer-resolution-list">
    {{if $data.resolution}}
    {{each $data.resolution}}
    <div
      class="mfunsPlayer-resolution-item {{if $value.isDefault}}focus{{/if}} {{if $value.disable}}disable{{/if}}"
      data-resolution="{{ $value }}"
    >
      {{ $value.name + " " + $value.label }}
      {{if $value.suffix}}
      <div class="suffix">{{ $value.suffix }}</div>
      {{/if}}
    </div>
    {{/each}}
    {{/if}}
    {{if !$data.resolution}}
    <div class="mfunsPlayer-resolution-item" data-resolution="unknown">未知</div>
    {{/if}}
  </div>
</div>
